export enum UserRequest {
  NoRequest = 0,
  MissionConfirmed = 1,
  MissionPause = 2
}
